import React from "react";
import Button from "@mui/material/Button";

export const CollapsibleSection: React.FC<{
    title: string;
    isOpen: boolean;
    onToggle: () => void;
    children: React.ReactNode;
    count?: number;
    icon?: string;
}> = ({ title, isOpen, onToggle, children, count, icon }) => {
    return (
        <div className="border-t border-slate-200 pt-4">
            <Button
                onClick={onToggle}
                fullWidth
                variant="text"
                sx={{
                    justifyContent: "space-between",
                    textTransform: "none",
                    textAlign: "left",
                }}
            >
                <div className="flex items-center gap-2">
                    {icon && (
                        <div
                            className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
                                isOpen
                                    ? "bg-slate-900 text-white"
                                    : "bg-slate-100 text-slate-600"
                            }`}
                        >
                            <i className={`fas ${icon} text-xs`} />
                        </div>
                    )}
                    <div>
                        <h4 className="text-sm font-semibold text-slate-900">
                            {title}
                        </h4>
                        {count !== undefined && (
                            <p className="text-xs text-slate-500">
                                {count} {count === 1 ? "item" : "items"}
                            </p>
                        )}
                    </div>
                </div>
                <div
                    className={`transition-all ${isOpen ? "rotate-180" : "rotate-0"}`}
                >
                    <i className="fas fa-chevron-down text-xs text-slate-400" />
                </div>
            </Button>
            {isOpen && (
                <div className="mt-3 pl-3 animate-in slide-in-from-top-2 duration-200">
                    {children}
                </div>
            )}
        </div>
    );
};
